import { loginPopupUpdate } from "auth/store/action";
import {
  GET_FINGERPRINT_FROM_NATIVE,
  LOGIN_ON_THE_GO,
} from "core-lib/constants/nativeBridge";
import { COOKIE } from "core-lib/types/Helper";
import { getCookieValue } from "core-lib/utils/cookie";
import { passMessageToNative, wait } from "core-lib/utils/nativeBridge";
import {
  isFingerprintAvailable,
  isNativeLoginOnTheGoEventAvailable,
} from "core-lib/utils/utils";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FINGERPRINT_REQUEST_ID,
  FINGERPRINT_VISITOR_ID,
  FINGERPRINT_PSK_ID,
} from "../constants/storage";
import { isParkPlusWebView } from "core-lib/utils/source";
export const useNativeAuth = () => {
  const { isAuthenticated } = useSelector((state) => state?.auth);
  const genRef = useRef(null);

  const dispatch = useDispatch();

  const getIsAuthenticated = () => !!getCookieValue(COOKIE.accessToken);

  const poll = async function (fn, fnCondition, ms) {
    let result = fn();
    while (result !== fnCondition) {
      // eslint-disable-next-line no-await-in-loop
      await wait(ms);
      // eslint-disable-next-line no-await-in-loop
      result = fn();
    }
    return result;
  };

  const callbackJSON = {
    success_script: `
        try{
        console.info('callback_script fired',window,document);
        window.localStorage.setItem('accessToken', '{{accessToken}}');
        window.localStorage.setItem('refreshToken', '{{refreshToken}}');
        window.localStorage.setItem('profile', '{{profile}}');
        document.getElementById("native_login_btn").click();
        }catch(e){
          console.error('callback_script error',e);
        }
        `,
    failure_script: ` document.getElementById("native_login_fail_btn").click();`,
  };
  function* loginGenerator() {
    if (isNativeLoginOnTheGoEventAvailable()) {
      passMessageToNative(LOGIN_ON_THE_GO, null, callbackJSON);
    } else if (isParkPlusWebView()) {
      if (isFingerprintAvailable()) {
        const callBackScript = `
        window.sessionStorage.setItem("${FINGERPRINT_PSK_ID}", "{{fingerprint_psk_id}}");
        window.sessionStorage.setItem("${FINGERPRINT_REQUEST_ID}", "{{fingerprint_request_id}}");
        window.sessionStorage.setItem("${FINGERPRINT_VISITOR_ID}", "{{fingerprint_visitor_id}}")`;
        passMessageToNative(GET_FINGERPRINT_FROM_NATIVE, null, callBackScript);
      }
      dispatch(loginPopupUpdate({ show: true }));
    } else {
      dispatch(loginPopupUpdate({ show: true }));
    }
    yield "hold";
    return true;
  }

  async function makeUserLogin() {
    if (!isAuthenticated) {
      genRef.current = loginGenerator();
      genRef.current.next();
      const res = await poll(getIsAuthenticated, true, 100);
      await wait(500);
      return res;
    }
    return null;
  }

  return {
    login: makeUserLogin,
  };
};
